import Vue from 'vue';
import Router from 'vue-router';
import $store from '../store'
import AuthLayout from "../layouts/AuthLayout";
import MainLayout from "../layouts/MainLayout";
import LoginPage from "../pages/auth/LoginPage";
import DashboardPage from "../pages/dashboard/DashboardPage.vue";
import MailListingAllPage from "../pages/main/mails/MailListingAllPage";
import MailListingDraftPage from "../pages/main/mails/MailListingDraftPage";
import MailListingSentPage from "../pages/main/mails/MailListingSentPage";
import RegisterPage from "../pages/auth/RegisterPage";
import MailCreatePdfFormPage from "../pages/main/mails/create/MailCreatePdfFormPage";
import MailPage from "../pages/main/mails/MailPage";
import UserUnitStatisticsPage from "@/pages/main/UserUnitStatisticsPage";
import TrackPage from '@/pages/TrackPage'
import AdminLayout from "@/layouts/AdminLayout";
import AdminDashboardPage from "@/pages/dashboard/AdminDashboardPage.vue";
import UsersPage from "@/pages/user/UsersPage";
import UnitsPage from "@/pages/unit/UnitsPage";
import UnitStatisticsPage from "@/pages/statistics/UnitStatisticsPage";
import AdminMailsPage from "@/pages/admin/AdminMailsPage";
import {Moderator, Revizor} from "@/enums/user.type";
import ModeratorLayout from "@/layouts/ModeratorLayout";
import ModeratorDashboardPage from "@/pages/dashboard/ModeratorDashboardPage.vue";
import ModeratorMailsPage from "@/pages/moderator/ModeratorMailsPage";
import MonitoringLayout from "@/layouts/MonitoringLayout";
import MonitoringDashboardPage from "@/pages/dashboard/MonitoringDashboardPage.vue";
import MonitoringMailsPage from "@/pages/monitoring/MonitoringMailsPage";
import RegionStatisticsPage from "../pages/statistics/RegionStatisticsPage";
import OrganizationStatisticsPage from "../pages/statistics/OrganizationStatisticsPage";
import ClientStatisticsPage from "../pages/statistics/ClientStatisticsPage";
import ClientUnitStatisticsPage from "../pages/statistics/ClientUnitStatisticsPage";
import OrganizationsPage from "../pages/organization/OrganizationsPage";
import TemplatePage from "@/pages/template/TemplatePage.vue";
import MailImportRegistryFormPage from "../pages/main/mails/create/MailImportRegistryFormPage";
import GlobalOrganizationPage from "@/pages/organization/GlobalOrganizationPage.vue";
import GlobalUnitsPage from "@/pages/unit/GlobalUnitsPage.vue";
import GlobalUserPage from "@/pages/user/GlobalUserPage.vue";
import RegistryPermissionPage from "@/pages/registry-permission/RegistryPermissionPage.vue";
import TemplateDashboardPage from "@/pages/dashboard/TemplateDashboardPage.vue";
import GlobalDashboardPage from "@/pages/dashboard/GlobalDashboardPage.vue";
import AdminStatisticsDashboardPage from "@/pages/dashboard/AdminStatisticsDashboardPage.vue";
import MonitoringStatisticsDashboardPage from "@/pages/dashboard/MonitoringStatisticsDashboardPage.vue";
import ModeratorStatisticsDashboardPage from "@/pages/dashboard/ModeratorStatisticsDashboardPage.vue";
import AreaStatisticsPage from "@/pages/statistics/AreaStatisticsPage.vue";
import ClientAreaStatisticsPage from "@/pages/statistics/ClientAreaStatisticsPage.vue";
import RevizorLayout from "@/layouts/RevizorLayout.vue";
import RevizorDashboardPage from "@/pages/dashboard/RevizorDashboardPage.vue";
import RevizorClientStatisticsPage from "@/pages/statistics/RevizorClientStatisticsPage.vue";
import RevizorClientAreaStatisticsPage from "@/pages/statistics/RevizorClientAreaStatisticsPage.vue";
import RevizorClientUnitStatisticsPage from "@/pages/statistics/RevizorClientUnitStatisticsPage.vue";

Vue.use(Router);

let router = new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            redirect: {name: 'dashboard'}
        },
        {
            path: '/track/:uid',
            name: 'track',
            component: TrackPage,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/auth',
            component: AuthLayout,
            meta: {
                requiresAuth: false
            },
            redirect: {name: 'login'},
            children: [
                {
                    path: 'login',
                    name: 'login',
                    component: LoginPage
                },
                {
                    path: 'register',
                    name: 'register',
                    component: RegisterPage
                }
            ]
        },
        {
            path: '/main',
            component: MainLayout,
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    component: DashboardPage
                },
                {
                    path: 'mails/listing/draft',
                    name: 'mails-listing-draft',
                    component: MailListingDraftPage
                },
                {
                    path: 'mails/listing/sent',
                    name: 'mails-listing-sent',
                    component: MailListingSentPage
                },
                {
                    path: 'mails/listing/all',
                    name: 'mails-listing-all',
                    component: MailListingAllPage
                },
                {
                    path: 'mail/create/excel/registry',
                    name: 'mail-create-excel-registry',
                    component: MailImportRegistryFormPage
                },
                {
                    path: 'mail/create/pdf-form',
                    name: 'mail-create-pdf-form',
                    component: MailCreatePdfFormPage
                },
                {
                    path: 'mail/view/:id',
                    name: 'mail-view',
                    component: MailPage
                },
                {
                    path: 'units',
                    name: 'user-unit-statistics-page',
                    component: UserUnitStatisticsPage
                },
            ]
        },
        {
            path: '/admin',
            component: AdminLayout,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
            },
            children: [
                {
                    path: '',
                    name: 'admin-dashboard',
                    component: AdminDashboardPage
                },
                {
                    path: 'organizations',
                    name: 'admin-organizations',
                    component: OrganizationsPage
                },
                {
                    path: 'global/organizations',
                    name: 'admin-globalorganizations',
                    component: GlobalOrganizationPage
                },
                {
                    path: 'statistics/region',
                    name: 'admin-statistics-region',
                    component: RegionStatisticsPage
                },
                {
                    path: 'statistics/area',
                    name: 'admin-statistics-area',
                    component: AreaStatisticsPage
                },
                {
                    path: 'statistics/organization',
                    name: 'admin-statistics-organization',
                    component: OrganizationStatisticsPage
                },
                {
                    path: 'statistics/unit',
                    name: 'admin-statistics-unit',
                    component: UnitStatisticsPage
                },
                {
                    path: 'mails',
                    name: 'admin-mails',
                    component: AdminMailsPage
                },
                {
                    path: 'statistics/client',
                    name: 'admin-client-statistics',
                    component: ClientStatisticsPage
                },
                {
                    path: 'statistics/client-area',
                    name: 'admin-client-area-statistics',
                    component: ClientAreaStatisticsPage
                },
                {
                    path: 'statistics/clientunit',
                    name: 'admin-client-unit-statistics',
                    component: ClientUnitStatisticsPage
                },
                {
                    path: 'template',
                    name: 'admin-template',
                    component: TemplatePage
                },
                {
                    path: 'registry-permission',
                    name: 'registry-permission',
                    component: RegistryPermissionPage
                },
                {
                    path: 'admin-template',
                    name: 'template-dashboard-page',
                    component: TemplateDashboardPage
                },
                {
                    path: 'global',
                    name: 'global-dashboard-page',
                    component: GlobalDashboardPage
                },
                {
                    path: 'statistics',
                    name: 'admin-statistics-dashboard-page',
                    component: AdminStatisticsDashboardPage
                },
                {
                    path: 'users',
                    name: 'admin-users',
                    component: UsersPage
                },
                {
                    path: 'global/users',
                    name: 'admin-globalusers',
                    component: GlobalUserPage
                },
                {
                    path: 'units',
                    name: 'admin-units',
                    component: UnitsPage
                },
                {
                    path: 'global/units',
                    name: 'admin-globalunits',
                    component: GlobalUnitsPage
                }
            ]
        },
        {
            path: '/revizor',
            component: RevizorLayout,
            meta: {
                requiresAuth: true,
                requiresRevizor: true
            },
            children: [
                {
                    path: 'statistics/client',
                    name: 'revizor-client-statistics',
                    component: RevizorClientStatisticsPage
                },
                {
                    path: 'statistics/client-area',
                    name: 'revizor-client-area-statistics',
                    component: RevizorClientAreaStatisticsPage
                },
                {
                    path: 'statistics/clientunit',
                    name: 'revizor-client-unit-statistics',
                    component: RevizorClientUnitStatisticsPage
                },
                {
                    path: 'dashboard',
                    name: 'revizor-dashboard',
                    component: RevizorDashboardPage
                }
            ]
        },
        {
            path: '/moderator',
            component: ModeratorLayout,
            meta: {
                requiresAuth: true,
                requiresAdmin: false,
                requiresModerator: true
            },
            children: [
                {
                    path: '',
                    name: 'moderator-dashboard',
                    component: ModeratorDashboardPage
                },
                {
                    path: 'organizations',
                    name: 'moderator-organizations',
                    component: OrganizationsPage
                },
                {
                    path: 'users',
                    name: 'moderator-users',
                    component: UsersPage
                },
                {
                    path: 'units',
                    name: 'moderator-units',
                    component: UnitsPage
                },
                {
                    path: 'mails',
                    name: 'moderator-mails',
                    component: ModeratorMailsPage
                },
                {
                    path: 'statistics/region',
                    name: 'moderator-statistics-region',
                    component: RegionStatisticsPage
                },
                {
                    path: 'statistics/area',
                    name: 'moderator-statistics-area',
                    component: AreaStatisticsPage
                },
                {
                    path: 'statistics/organization',
                    name: 'moderator-statistics-organization',
                    component: OrganizationStatisticsPage
                },
                {
                    path: 'statistics/unit',
                    name: 'moderator-statistics-unit',
                    component: UnitStatisticsPage
                },
                {
                    path: 'statistics/client',
                    name: 'moderator-statistics-client',
                    component: ClientStatisticsPage
                },
                {
                    path: 'statistics/clientunit',
                    name: 'moderator-client-unit-statistics',
                    component: ClientUnitStatisticsPage
                },
                {
                    path: 'statistics/client-area',
                    name: 'moderator-client-area-statistics',
                    component: ClientAreaStatisticsPage
                },
                {
                    path: 'statistics-dashboard-page',
                    name: 'moderator-statistics-dashboard-page',
                    component: ModeratorStatisticsDashboardPage
                }
            ]
        },
        {
            path: '/monitoring',
            component: MonitoringLayout,
            meta: {
                requiresAuth: true,
                requiresAdmin: false,
                requiresModerator: false
            },
            children: [
                {
                    path: '',
                    name: 'monitoring-dashboard',
                    component: MonitoringDashboardPage
                },
                {
                    path: 'statistics/region',
                    name: 'monitoring-statistics-region',
                    component: RegionStatisticsPage
                },
                {
                    path: 'statistics/area',
                    name: 'monitoring-statistics-area',
                    component: AreaStatisticsPage
                },
                {
                    path: 'statistics',
                    name: 'monitoring-statistics-dashboard-page',
                    component: MonitoringStatisticsDashboardPage
                },
                {
                    path: 'statistics/organization',
                    name: 'monitoring-statistics-organization',
                    component: OrganizationStatisticsPage
                },
                {
                    path: 'statistics/unit',
                    name: 'monitoring-statistics-unit',
                    component: UnitStatisticsPage
                },
                {
                    path: 'mails',
                    name: 'monitoring-mails',
                    component: MonitoringMailsPage
                },
                {
                    path: 'statistics/client',
                    name: 'monitoring-statistics-client',
                    component: ClientStatisticsPage
                },
                {
                    path: 'statistics/client-area',
                    name: 'monitoring-client-area-statistics',
                    component: ClientAreaStatisticsPage
                },
                {
                    path: 'statistics/clientunit',
                    name: 'monitoring-client-unit-statistics',
                    component: ClientUnitStatisticsPage
                }
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
        next({name: 'dashboard'})
    }

    if (to.matched.some(record => record.meta.requiresAdmin)) {
        if ($store.getters.isAdminTokenOk) {
            next()
        } else {
            next({name: 'login'})
        }
    } else if (to.matched.some(record => record.meta.requiresRevizor)) {
        if ($store.getters.appIsInitialized && $store.getters.appLogin.type === Revizor) {
            next()
        } else {
            next({name: 'login'})
        }
    } else if (to.matched.some(record => record.meta.requiresModerator)) {
        if ($store.getters.appIsInitialized && $store.getters.appLogin.type === Moderator) {
            next();
        } else {
            next({name: 'login'})
        }
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        if ($store.getters.isTokenOk) {
            next();
        } else {
            next({name: 'login'})
        }
    } else {
        next()
    }
})

export default router
